"use strict";

var _objectWithoutProperties = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _ = _interopRequireDefault(require("../"));

var _gsap = _interopRequireDefault(require("gsap"));

var _colorConvert = _interopRequireDefault(require("color-convert"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/AniLink/PaintDrip.js";

var PaintDrip = /*#__PURE__*/function (_react$Component) {
  _inherits(PaintDrip, _react$Component);

  var _super = _createSuper(PaintDrip);

  function PaintDrip(props) {
    var _this;

    _classCallCheck(this, PaintDrip);

    _this = _super.call(this, props);

    _this.createRipple = function (_ref, event, hex, color, node) {
      var length = _ref.length;
      var body = document.body;
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var piTwo = Math.PI * 2;
      var rgb = hex ? _colorConvert.default.hex.rgb(hex).join(',') : '0,0,255';
      rgb = color ? _colorConvert.default.keyword.rgb(color) : rgb;
      canvas.style.zIndex = 10000;
      canvas.style.top = 0;
      canvas.style.position = 'fixed';
      var vw = canvas.width = window.innerWidth;
      var vh = canvas.height = window.innerHeight;
      body.appendChild(canvas); // Event coords

      var x = event.clientX;
      var y = event.clientY; // Delta - difference between event and farthest corner

      var dx = x < vw / 2 ? vw - x : x;
      var dy = y < vh / 2 ? vh - y : y;
      var radius = Math.sqrt(dx * dx + dy * dy);
      var ripple = {
        alpha: 0,
        radius: 0,
        x: x,
        y: y
      };
      var seconds = length;

      _gsap.default.timeline({
        onUpdate: drawRipple,
        onComplete: function onComplete() {
          return removeCanvas(seconds / 3);
        }
      }).to(ripple, {
        alpha: 1,
        duration: seconds / 4
      }).to(ripple, {
        radius: radius,
        ease: "power1.easeIn",
        duration: seconds - seconds / 3
      }, 0).set(node, {
        visibility: 'hidden'
      }).to(canvas, {
        x: '100%',
        ease: "power1.easeIn",
        duration: seconds / 3
      }, "+=".concat(seconds * 0.4));

      function drawRipple() {
        ctx.clearRect(0, 0, vw, vh);
        ctx.beginPath();
        ctx.arc(ripple.x, ripple.y, ripple.radius, 0, piTwo, false);
        var fillStyle = "rgba(".concat(rgb, ",").concat(ripple.alpha, ")");
        ctx.fillStyle = fillStyle;
        ctx.fill();
      }

      window.addEventListener('resize', onResize);

      function removeCanvas() {
        var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        setTimeout(function () {
          body.removeChild(canvas);
        }, wait);
      }

      function onResize() {
        vw = canvas.width = window.innerWidth;
        vh = canvas.height = window.innerHeight;
      }
    };

    _this.getDirection = function (from) {
      switch (from) {
        case 'left':
          return {
            xPercent: -5
          };

        case 'right':
          return {
            xPercent: 5
          };

        case 'top':
          return {
            yPercent: -5
          };

        case 'bottom':
          return {
            yPercent: 5
          };

        default:
          return {};
      }
    };

    _this.slideIn = function (_ref2, node, from) {
      var length = _ref2.length;

      _gsap.default.from(node, length, _objectSpread(_objectSpread({}, _this.getDirection(from)), {}, {
        ease: 'power1.easeOut'
      }));
    };

    _this.onResize = function () {
      _this.vw = _this.canvas.width = window.innerWidth;
      _this.vh = _this.canvas.height = window.innerHeight;
    };

    _this.createRipple = _this.createRipple.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PaintDrip, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          removedExit = _this$props.exit,
          removedEntry = _this$props.entry,
          removedProp = _this$props.paintDrip,
          duration = _this$props.duration,
          _this$props$direction = _this$props.direction,
          direction = _this$props$direction === void 0 ? 'left' : _this$props$direction,
          props = _objectWithoutProperties(_this$props, ["exit", "entry", "paintDrip", "duration", "direction"]);

      var aniLength = duration || 1;
      var aniDelay = aniLength / 1.75;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.default, (0, _extends2.default)({
        exit: {
          length: aniLength,
          trigger: function trigger(_ref3) {
            var exit = _ref3.exit,
                e = _ref3.e,
                node = _ref3.node;
            return _this2.createRipple(exit, e, props.hex, props.color, node);
          }
        },
        entry: {
          delay: aniDelay,
          length: aniLength,
          trigger: function trigger(_ref4) {
            var entry = _ref4.entry,
                node = _ref4.node;
            return _this2.slideIn(entry, node, direction);
          }
        }
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 145,
          columnNumber: 5
        }
      }), props.children));
    }
  }]);

  return PaintDrip;
}(_react.Component);

exports.default = PaintDrip;